import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { useHistory } from "react-router-dom";

import {Content,
        TitleContainer,
        DataContainer,
        ButtonContainer} from './styles';

import { FiX } from 'react-icons/fi';
import { useCallback, useState } from 'react';
import api from '../../services/api';

interface IUsers{
    first_name: string;
    email: string;
    phone: string;
}

interface IModalShowClients{
    open: boolean;
    functionToClose(): void;
    client: IUsers;
    owner: IUsers;
    offerId: string;
}

export default function ModalShowClients({ open, functionToClose, client, owner, offerId }: IModalShowClients){
    const [openingDocs, setOpeningDocs] = useState(false);
    const history = useHistory();

    const handleGoToDocuments = useCallback(async () => {
        try {
            setOpeningDocs(true);

            const res = await api.get("/api/adm/documents/files/rent-process-by-offer", {
                params: { offer_id: offerId },
            });

            const rentProcessId = res.data?.data?.rent_process_id;

            if (!rentProcessId) {
                alert("Não foi possível encontrar o processo de locação desta oferta.");
                return;
            }

            history.push("/documents/1", { rentProcessId });
                functionToClose();
        } catch (err: any) {
            console.error(err);
            alert(err?.response?.data?.message ?? "Erro ao abrir documentos.");
        } finally {
            setOpeningDocs(false);
        }
    }, [offerId, history, functionToClose]);

    return(
        <Modal open={open} onClose={functionToClose} classNames={{
            modal: 'modalClients'
        }} closeIcon={(<FiX size={18} color="#000"/>)}>
            <Content>
                <TitleContainer>
                    <h3>Dados do Cliente</h3>
                </TitleContainer>

                <DataContainer>
                    <h3>Cliente</h3>

                    <p><b>Nome: </b> {client.first_name}</p>
                    <p><b>Email: </b> {client.email}</p>
                    <p><b>Telefone: </b> {client.phone}</p>
                </DataContainer>

                <DataContainer>
                    <h3>Proprietário</h3>

                    <p><b>Nome: </b> {!!owner ? owner.first_name : ''}</p>
                    <p><b>Email: </b> {!!owner ? owner.email : ''}</p>
                    <p><b>Telefone: </b> {!!owner ? owner.phone : ''}</p>
                </DataContainer>

                <ButtonContainer>
                    <button onClick={openingDocs ? () => {} : handleGoToDocuments}>
                        {openingDocs ? "Abrindo..." : "Ver documentos"}
                    </button>

                    <button style={{backgroundColor: "transparent", color: "#000", border: "1px solid #606062"}} onClick={functionToClose}>Fechar</button>
                </ButtonContainer>
            </Content>
        </Modal>
    );
}